import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import ExportDataFilter from "./ExportDataFilter";
import ExportDataDisplay from "./ExportDataDisplay";
import local from "../../../localization/strings";
import PageTitle from "../../common/PageTitle";
import useWindowSize from "../../../hooks/useWindowSize";
import { userPreferencesGetList, userPreferenceSave } from "../../../api/userPreferences";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { logEvent } from "../../../helpers/ga";
import { isFeatureEnabled, features } from "../../../config";
import EmailModal from "../../common/EmailModal";

const buttonDefaultClasses = "btn-shadow btn-sm mb-sm-2 py-2 px-2 px-sm-3 py-sm-1";

const ExportData = () => {
	const [showFilter, setShowFilter] = useState(true);
	const [reportRunning, setReportRunning] = useState(false);
	const [data, setData] = useState({});
	const [showEmail, setShowEmail] = useState(false);
	const size = useWindowSize();

	const generateStats = async (data) => {
		await userPreferenceSave("ExportDataReport_Filter", JSON.stringify(data));

		setReportRunning(true);
		setData(data);
		setShowFilter(false);
	};

	const filter = () => {
		logEvent("Export Data", "Filter");

		setShowFilter(true);
	};

	useEffect(() => {
		const LoadData = async () => {
			const prefs = await userPreferencesGetList();

			var match = prefs.find((x) => x.preferenceKey === "ExportDataReport_Filter");

			if (match) {
				setData(JSON.parse(match.preferenceValue));
			}
		};

		LoadData();
	}, []);

	useEffect(() => {
		var dashboardContentDiv = document.getElementById("dashboard-container-div");

		if (dashboardContentDiv) {
			var contentDiv = document.getElementById("toolbar-row");
			contentDiv.style.marginRight = `-${dashboardContentDiv.offsetLeft}px`;
		}
	}, [size]);

	const toggleEmailModal = () => {
		setShowEmail(!showEmail);
	};

	return (
		<>
			<PageTitle title={local.TS_ExportData} />

			<Row id="toolbar-row" className="justify-content-between">
				{showFilter ? (
					""
				) : (
					<>
						<Col className="col-3">
							<Button size="sm" color="secondary" className={buttonDefaultClasses} onClick={() => filter()}>
								<FontAwesomeIcon icon="filter" />
								<span className="d-none d-md-inline-block ml-2">{local.TS_Filter}</span>
							</Button>
						</Col>
						<Col className="col-3 p-0">
							<UncontrolledDropdown size="sm" direction="left" className="allow-overflow float-right d-none">
								<DropdownToggle caret color="info" transform="shrink-3" className={buttonDefaultClasses} disabled={reportRunning}>
									<FontAwesomeIcon icon="share-alt" />
									<span className="d-none d-md-inline-block ml-2">{local.TS_Options}</span>
								</DropdownToggle>
								<DropdownMenu className="menu-border-blue dropdown-menu">
									{/* v0.9 */}
									<DropdownItem disabled>
										<FontAwesomeIcon icon="download" /> {local.TS_Download}
									</DropdownItem>
									<DropdownItem disabled>
										<FontAwesomeIcon icon="print" /> {local.TS_Print}
									</DropdownItem>
									<DropdownItem disabled>
										<FontAwesomeIcon icon="copy" /> {local.TS_Copy}
									</DropdownItem>
									{isFeatureEnabled(features.ReportEmail) && (
										<DropdownItem onClick={() => toggleEmailModal}>
											<FontAwesomeIcon icon="envelope-square" /> {local.TS_Email}
										</DropdownItem>
									)}
								</DropdownMenu>
							</UncontrolledDropdown>
						</Col>
					</>
				)}
			</Row>
			<Card className="p-3" id="export-data-report-div">
				{showFilter ? <ExportDataFilter triggerGenerate={generateStats} filterData={data} /> : <ExportDataDisplay filterData={data} setReportRunning={setReportRunning} />}
			</Card>
			<EmailModal show={showEmail} toggleEmailModal={toggleEmailModal} />
		</>
	);
};

export default ExportData;
